import axiosInstance from '../config/axios';
 
export const drugService = {
  getAllDrugs: () => axiosInstance.get('/drugs').then(res => res.data),
  getHomeOverview: () => axiosInstance.get('/drugs/home-overview').then(res => res.data),
  getDrug: (id) => axiosInstance.get(`/drugs/${id}`).then(res => res.data),
  createDrug: (data) => axiosInstance.post('/drugs', data).then(res => res.data),
  updateDrug: (id, data) => axiosInstance.put(`/drugs/${id}`, data).then(res => res.data),
  deleteDrug: (id) => axiosInstance.delete(`/drugs/${id}`).then(res => res.data),
}; 